import { render, staticRenderFns } from "./customer_edit.vue?vue&type=template&id=dbd4dd7e&scoped=true&"
import script from "./customer_edit.vue?vue&type=script&lang=js&"
export * from "./customer_edit.vue?vue&type=script&lang=js&"
import style0 from "./customer_edit.vue?vue&type=style&index=0&id=dbd4dd7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd4dd7e",
  null
  
)

export default component.exports